import { acharBanco, corDoTextoSobre, iniciaisDoBanco } from '../lib/bancos'
import { LOGOS_BANCOS } from '../lib/bancosLogos'

/**
 * Logo da instituição. Usa o arquivo baixado (scripts/baixar-logos-bancos.mjs); sem ele, um selo com as
 * iniciais na cor da marca. Retorna null para texto que não é um banco conhecido — quem chama mantém o ícone.
 */
export function BancoLogo({ nome, size = 40 }: { nome: string; size?: number }) {
  const banco = acharBanco(nome)
  if (!banco) return null
  const box = { width: size, height: size, borderRadius: size * 0.25 }
  if (LOGOS_BANCOS.has(banco.slug)) {
    return (
      <span className="inline-flex flex-shrink-0 items-center justify-center overflow-hidden bg-white" style={box}>
        <img src={`${import.meta.env.BASE_URL}bancos/${banco.slug}.png`} alt={banco.nome} style={{ width: size * 0.72, height: size * 0.72 }} className="object-contain" />
      </span>
    )
  }
  return (
    <span
      className="inline-flex flex-shrink-0 items-center justify-center font-bold"
      style={{ ...box, background: banco.cor, color: corDoTextoSobre(banco.cor), fontSize: size * 0.36 }}
      role="img" aria-label={banco.nome}
    >
      {iniciaisDoBanco(banco.nome)}
    </span>
  )
}
